export default {
  currentDrawer: "",
};
